/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Decorrenza della scadenza relativa del voucher
 */
export enum ScadenzaVoucherDecorrenza {

    EMISSIONE = 'EMISSIONE',

    CONSEGNA = 'CONSEGNA'
}

